import React from 'react';
import { Closure } from '../../types/inspection';
import { CheckCircle2, Archive, Clock, Star } from 'lucide-react';

interface ClosureSummaryCardProps {
  closure: Closure;
}

export const ClosureSummaryCard: React.FC<ClosureSummaryCardProps> = ({ closure }) => {
  return (
    <div className="p-5 bg-slate-900 border border-slate-800 rounded-xl space-y-4">
      <div className="flex items-center gap-3">
        <div className="p-3 bg-emerald-500/10 text-emerald-400 rounded-xl">
          <CheckCircle2 className="w-6 h-6" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-slate-100">Complaint Closed</h3>
          <p className="text-xs text-slate-400">{closure.closure_id}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 text-xs">
        <div className="p-3 bg-slate-950 rounded-lg border border-slate-800">
          <p className="text-[10px] text-slate-500">Closed At</p>
          <p className="font-semibold text-slate-200">{new Date(closure.closed_at).toLocaleString()}</p>
        </div>
        <div className="p-3 bg-slate-950 rounded-lg border border-slate-800">
          <p className="text-[10px] text-slate-500">Closed By</p>
          <p className="font-semibold text-slate-200">{closure.closed_by_user_name}</p>
        </div>
        <div className="p-3 bg-slate-950 rounded-lg border border-slate-800">
          <p className="text-[10px] text-slate-500">Total Duration</p>
          <p className="font-semibold text-slate-200 flex items-center gap-1">
            <Clock className="w-3 h-3 text-amber-400" />
            {closure.total_duration_hours}h
          </p>
        </div>
        <div className="p-3 bg-slate-950 rounded-lg border border-slate-800">
          <p className="text-[10px] text-slate-500">Satisfaction</p>
          <p className="font-semibold text-slate-200 flex items-center gap-1">
            <Star className="w-3 h-3 text-amber-400 fill-amber-400" />
            {closure.satisfaction_rating}/5
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 p-3 bg-slate-950 rounded-lg border border-slate-800">
        <Archive className="w-5 h-5 text-sky-400" />
        <div>
          <p className="text-[10px] text-slate-500">Archive Eligibility</p>
          <p className={`text-xs font-semibold ${closure.archive_eligible ? 'text-emerald-400' : 'text-slate-400'}`}>
            {closure.archive_eligible ? 'Eligible for Archive' : 'Not Eligible'}
          </p>
        </div>
      </div>
    </div>
  );
};
